"use client";

import { useNotifications } from "@/lib/notifications/useNotifications";

/**
 * Client component wrapper for notifications polling
 * This component should be included in the root layout to start polling
 * on all pages. It doesn't render anything - it just manages the polling.
 */
export function NotificationsProvider() {
  useNotifications();
  return null;
}
